export enum CompanyPage {
  Simple = 'simple',
  Company = 'company',
}
